import {Box, Clickable, Image, Spinner, Show, ClickableProps} from 'platform/foundation';

import {Sortable} from '@dms/features/dnd';

import {RequiredTestIdProps, suffixTestId} from 'shared/web';

interface SimpleAlbumImageProps extends RequiredTestIdProps {
  id: string;
  src: string;
  isGhost?: boolean;
  isLoading?: boolean;
  isDisabled?: boolean;
  onClick?: () => void;
  onContextMenu?: ClickableProps['onContextMenu'];
}

export const SimpleAlbumImage = (props: SimpleAlbumImageProps) => (
  <Clickable
    data-testid={suffixTestId('simpleAlbumImage', props)}
    onClick={props.onClick}
    onContextMenu={(event) => {
      event.preventDefault();
      props.onContextMenu?.(event);
    }}
  >
    <Sortable
      id={props.id}
      disabledDrag={props.isLoading || props.isGhost || props.isDisabled}
      disabledDrop={props.isLoading || props.isGhost || props.isDisabled}
    >
      {({isDragging}) => (
        <Box
          ratio="4 / 3"
          width="100%"
          overflow="hidden"
          position="relative"
          borderRadius="small"
          opacity={isDragging || props.isGhost ? 0.5 : 1}
        >
          <Image
            data-testid={suffixTestId('simpleAlbumImage', props)}
            width="100%"
            draggable={false}
            borderRadius="small"
            height="100%"
            src={props.src}
            fit="cover"
            hasSpinner
          />
          <Show when={props.isLoading}>
            <Spinner data-testid={suffixTestId('albumImage', props)} variant="overlay" />
          </Show>
        </Box>
      )}
    </Sortable>
  </Clickable>
);
